import React from 'react';
import PropTypes from 'prop-types';
import { compose, withStateHandlers } from 'recompose';
import Button from '../../../../components/Button';

import * as styles from './styles.css';

const getBtnVariant = (val) => {
  if (val === 'available') {
    return 'success';
  }
  if (val === 'unavailable') {
    return 'danger';
  }

  return 'default';
};

function StateButton({ switchState, input: { value } }) {
  return (
    <Button
      onClick={switchState}
      variant={getBtnVariant(value)}
      className={styles.stateBtn}
    >
      <i className={`fa fa-square ${styles[`state-${getBtnVariant(value)}`]}`} />
    </Button>
  );
}

StateButton.propTypes = {
  switchState: PropTypes.func.isRequired,
  input: PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  }).isRequired,
};

export default compose(
  withStateHandlers(({ input: { value } }) => ({ lastState: value }), {
    switchState: ({ lastState }, { input }) => () => {
      switch (input.value) {
        case 'available':
          input.onChange('unknown');
          return {};
        case 'unavailable':
          input.onChange('unknown');
          return {};
        default: {
          const nextState = lastState === 'available' ? 'unavailable' : 'available';
          input.onChange(nextState);
          return { lastState: nextState };
        }
      }
    },
  }),
)(StateButton);
